import { setCustomTagHTML } from 'helpers/helpers';
import FormSelect from 'ui/FormSelect/formSelect.module';
import { formInputData } from './formInput.model';
import { FormInputTemplate } from './formInput.template';

export default class FormInput {
	constructor(props) {
		this.initData(props);
		this.initWrapper(props);
	}

	initData(propData = {}) {
		this.data = formInputData;
		this.setter(propData);
	}

	initWrapper(props = {}) {
		const wrapper = document.createElement('div');
		wrapper.style.marginTop = '10px';
		if (props?.style) {
			wrapper.style = props.style;
		}
		wrapper.innerHTML = FormInputTemplate(props);
		if (props.inputWithSelect) {
			const selectInput = new FormSelect({
				...props,
				display_name: '',
				overrideInputClass: 'engt-select-override',
				overrideOptions: props.overrideOptionsClass || '',
				options: props.selectOptions,
			}).render();
			selectInput.id = `form-select-box-${props.attribute_id}`;
			selectInput.style.width = '30%';
			selectInput.style.alignSelf = 'flex-end';
			setCustomTagHTML(wrapper.querySelector('select-box'), selectInput);
		}
		this.html = wrapper;
	}

	initEventHandlers() {}

	setter(propData) {
		this.data = {
			...this.data,
			...propData,
		};
	}

	render() {
		return this.html;
	}
}
